import { connect } from 'react-redux'
import OrganisationFilesTable from './organisation-files-table'
import { getOrganisationFilesList } from '../../../../../stores/organisation-files/organisation-files.selectors'

const mapStateToProps = state => ({
  organisationFiles: getOrganisationFilesList(state)
})

export default connect(
  mapStateToProps,
  null
)(OrganisationFilesTable)
